import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class PricingSettingStore extends LocalModel {
    constructor() {
        super('pricingSetting', {
            namePlural: 'pricingSettings',
            namePluralReal: 'pricingSettings',
            sort: 'id',
            limit: 1,
            api: {
                load: {
                    url: '/api/pricingSettings/admin/',
                    params: {},
                },
                save: {
                    url: '/api/pricingSettings/admin/',
                    params: {},
                },
            },
        });
    }

    @observable pricingSetting = {};

    @observable pricingSettings = [];

    // Billable AI unit descriptors served by the backend (labels, billing mode,
    // product numbers) — the admin dashboard prices usage with them.
    @observable aiUsageUnitTypes = [];

    @action
    async loadSettings() {
        const response = await util.fetchApi('/api/pricingSettings/admin/', { method: 'GET' }, {});
        if (response && response.data) {
            const setting = Array.isArray(response.data) ? (response.data[0] || {}) : response.data;
            this.updateKeyValue('pricingSetting', setting);
            if (response.included && Array.isArray(response.included.aiUsageUnitTypes)) {
                this.updateKeyValue('aiUsageUnitTypes', response.included.aiUsageUnitTypes);
            }
        }
        return response;
    }
}

const store = new PricingSettingStore();
export default store;
